export default __webpack_public_path__ + "static/media/Facebook_logo.4d5055f7.png";